// jQueryプラグイン
import gsap from 'gsap';
import {
  ScrollTrigger
} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import { 
  ScrollToPlugin
} from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export function aboutFunc() {
  let aboutUsTop = $('#aboutUsTop').length;
  let aboutUsCreativity = $('#aboutUsCreativity').length;
  let aboutUsPurposePage = $('.aboutUsPurpose').length;
  let aboutUsCreativityPage = $('.aboutUsCreativity').length;

  let resizecheck = $('#responsibleCheck').width();

  $(window).on('resize', function () {
    resizecheck = $('#responsibleCheck').width();
  });

  if(aboutUsTop){
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));

    const header = document.getElementById("header");
    const subNav = document.getElementById('subNav');
    
    function txtParaRight(elm) {
      let winScroll = $(window).scrollTop();
      var windowH = window.innerHeight;
      var elm = $(elm);
      elm.each(function () {
        var elemO = elm.offset().top;
        var elemH = elm.height();

        if(winScroll > elemO - windowH && winScroll < elemO + elemH){
          elm.css('transform', 'translateX(' + ((elemO - winScroll) / 14) + 'px)');
        }
      });
    }
    function txtParaLeft(elm) {
      let winScroll = $(window).scrollTop();
      var windowH = window.innerHeight;
      var elm = $(elm);
      elm.each(function () {
        var elemO = elm.offset().top;
        var elemH = elm.height();

        if(winScroll > elemO - windowH && winScroll < elemO + elemH){
          elm.css('transform', 'translateX(' + ((winScroll - elemO) / 14) + 'px)');
        }
      });
    }

    function aboutUsCommonAnimeFunc() {
      $('.pageEntrance').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).hasClass('isShow')) {
              $(this).addClass('isShow');
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(500)
          })
          .then(() => {
              if (!$(this).find('.pageEntranceTit').hasClass('isShow')) {
                $(this).find('.pageEntranceTit').addClass('isShow');
                $(this).find('.btn01').addClass('isShow');

                if($(this).find('.pageEntranceTxt').length){
                  $(this).find('.pageEntranceTxt').addClass('isShow');
                }

                if($(this).find('.btn02').length){
                  $(this).find('.btn02').addClass('isShow');
                }
              }
              return wait(100)
          })
        }
      });
    }

    function aboutUsStoriesListMainviewAnimeFunc() {
      $('.storiesListMainview').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).hasClass('isShow')) {
              $(this).addClass('isShow');
            }
            return wait(500)
          })
          .then(() => {
              if (!$(this).find('.storiesListMainviewTit').hasClass('isShow')) {
                $(this).find('.img').addClass('isShow');
                $(this).find('.storiesListMainviewTit').addClass('isShow');
                $(this).find('.storiesListMainviewTxt').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
    }


    var scroll,scrollPosition,position;
    scrollPosition = $(window).scrollTop();
    var winH = $(window).height();
    // if(aboutUsPurposePage){
    //   var objH = $('#correlationDiagram').outerHeight();
    //   var objTop = $('#correlationDiagram').offset().top;
    // }
    // var objBottom = objTop + objH;

    var animatePurposeFlag01 = false;
    var animatePurposeFlag02 = false;
    var animatePurposeFlag03 = false;
    var animatePurposeFlag04 = false;
    var animatePurposeFlag05 = false;
    var animatePurposeFlag06 = false;
    var animatePurposeFlag07 = false;
    var animatePurposeFlag08 = false;
    var animatePurposeFlag09 = false;

    var animateScrollFlag01 = false;
    var animateScrollFlag02 = false;
    var animateScrollFlag03 = false;
    var animateScrollFlag04 = false;
    var animateScrollFlag05 = false;
    var animateScrollFlag06 = false;
    var animateScrollFlag07 = false;
    var animateScrollFlag08 = false;
    var animateScrollFlag09 = false;
    var animateScrollFlag10 = false;


    function aboutUsPurposeAnimeFunc() {
      if(!animatePurposeFlag02 && animateScrollFlag02){
        animatePurposeFlag02 = true;

        $('#txt1').animate({
          opacity: 0,
        }, 500, function () {
          $('#txt2').animate({
            opacity: 1,
          }, 1500);
          
          $(".svgAnime1").css({
            transform: "translateY(0)"
          }).delay(2500).queue(function(){
  
            animateScrollFlag03 = true;

          });
        });

        
      }
      if(!animatePurposeFlag03 && animateScrollFlag03){
        animatePurposeFlag03 = true;

        $('#txt2').animate({
          opacity: 0,
        }, 500, function () {
          $('#txt3').animate({
            opacity: 1,
          }, 1500);
          
          
          $(".svgAnime3").css({
            transform: "translateY(0)",
            opacity: "1"
          }).dequeue();
          $('.svgAnime4').css({
            transform: "translateY(0)",
            opacity: "1"
          });

          $('.back02').animate({
            opacity: 1,
          }, 3000).delay(1000).queue(function(){
            animateScrollFlag04 = true;
          });

        });

        
      }
      if(!animatePurposeFlag04 && animateScrollFlag04){
        animatePurposeFlag04 = true;

        $('#txt3').animate({
          opacity: 0,
        }, 500, function () {
          $('#txt4').animate({
            opacity: 1,
          }, 1500);

          //背景
          // $(".back03 , .back02").css({transform: "scale(1, 1)"}).dequeue().queue(function () {
          //   $(".back01").css({transform: "scale(1, 1)"}).dequeue().delay(1000);
          // });

          //ロゴと線
          $(".svgAnime5").css({
            transform: "translateY(0)",
            opacity: "1"
          }).dequeue();
          $(".svgAnime6").css({
            transform: "translateY(0)",
            opacity: "1"
          }).delay(3500).queue(function () {
            animateScrollFlag05 = true;
          });

        });

        
      }
      if(!animatePurposeFlag05 && animateScrollFlag05){
        animatePurposeFlag05 = true;

        $('#txt4').animate({
          opacity: 0,
        }, 500, function () {
          $('#txt5').animate({
            opacity: 1,
          }, 1500);

          $(".svgAnime7").css({
            transform: "translateY(0)",
            opacity: "1"
          }).dequeue();
          $(".svgAnime8").css({
            transform: "translateY(0)",
            opacity: "1"
          });
          $(".svgAnime9").css({
            transform: "scale(1, 1) translateZ(0)",
            opacity: "1"
          }).delay(1200).queue(function () {
            $(".svgAnime10").css({
              transform: "translateY(0)",
              opacity: "1"
            }).delay(2000).queue(function(){
              animateScrollFlag06 = true;
            });
          });
        });
      }
      if(!animatePurposeFlag06 && animateScrollFlag06){
        animatePurposeFlag06 = true;

        $('#txt5').animate({
          opacity: 0,
        }, 500, function () {
          $('#txt6').animate({
            opacity: 1,
          }, 1500);

          $('.svgAnime12').animate({
            opacity: 1,
          }, 1200);
          $('.svgAnime11').delay(2000).animate({
            opacity: 1,
          }, 1600).delay(1500).queue(function(){
            animateScrollFlag07 = true;
          });
        });
      }
      if(!animatePurposeFlag07 && animateScrollFlag07){
        animatePurposeFlag07 = true;

        $('#txt6').animate({
          opacity: 0,
        }, 500, function () {
          $('#txt7').animate({
            opacity: 1,
          }, 1500);

          $(".svgAnime13").css({
            transform: "translateY(0)",
            opacity: "1",
          }).dequeue().delay(650).queue(function(){
            $(".svgAnime14").css({
              opacity: "1"
            }).delay(2000).queue(function(){
              animateScrollFlag08 = true;
            });
          });
        });
      }
      if(!animatePurposeFlag08 && animateScrollFlag08){
        animatePurposeFlag08 = true;

        $('#txt7').animate({
          opacity: 0,
        }, 500, function () {
          $('#txt8').animate({
            opacity: 1,
          }, 1500);

          $(".svgAnime15").css({
            transform: "translateY(0)",
            opacity: "1"
          }).dequeue().delay(650).queue(function(){

            $('.svgAnime16').animate({
              opacity: 1,
            }, 1000);

            $(".back04").css({
              transform: "scale(1, 0)",
              opacity: "1"
            }).delay(1700).queue(function(){
              $('.svgAnime17').animate({
                opacity: 1,
              }, 1000).delay(1000).queue(function(){
                animateScrollFlag09 = true;
              });
            });

          });

        });
      }
      if(!animatePurposeFlag09 && animateScrollFlag09){
        animatePurposeFlag09 = true;

        $('#txt8').animate({
          opacity: 0,
        }, 500, function () {
          $('#txt9').animate({
            opacity: 1,
          }, 1500)
          .promise()
          .done(function() {
            header.classList.remove('changeHeightAbout');
            subNav.classList.remove('notTopAbout');
  
            $('body').removeClass('fixedBody').css({
              'top': 0
            });
            window.scrollTo(0, scrollPosition);
            animateScrollFlag10 = true;
          });

        });
      }
    }

    function aboutUsPurposeScrFunc() {
      scroll = $(window).scrollTop();
      if(scroll >= objBottom - winH){
  
        scrollPosition = $(window).scrollTop();

        if(!animateScrollFlag01){
          animateScrollFlag01 = true;

          if(scroll >= objTop - winH/2){
            $('body,html').animate({
              scrollTop: objBottom - winH
            }, 1000, function(){
              $('body').addClass('fixedBody').css({
                'top': -scrollPosition,
                'overflow-y': 'scroll',
              });
              header.classList.add('changeHeightAbout');
              subNav.classList.add('notTopAbout');
            });
          } else{
            $('body').addClass('fixedBody').css({
              'top': -scrollPosition,
              'overflow-y': 'scroll',
            });
            header.classList.add('changeHeightAbout');
            subNav.classList.add('notTopAbout');
          }
        }
  
        if(!animatePurposeFlag01 && animateScrollFlag01){
          animatePurposeFlag01 = true;
  
          $('#first').delay(1500).animate({
            opacity: 0,
            visibility: 'hidden',
          }, 1000 , function () {
            $('#animationBox').animate({
              opacity: 1,
            }, 1500).delay(1000).queue( function () {
              animateScrollFlag02 = true;
            });
          });
        }
        aboutUsPurposeAnimeFunc();
      }
    }

    /* --------------------------------------------------------------------
    You Tube処理
    -------------------------------------------------------------------- */
    var youtubeFunc = function () {
      $('p').find('iframe').wrap('<div class="youtube"></div>');
    }
    youtubeFunc();

    aboutUsCommonAnimeFunc();
    aboutUsStoriesListMainviewAnimeFunc();

    if(aboutUsPurposePage){
      aboutUsPurposeScrFunc();
    }

    txtParaRight('.missionDecoTxt');
    txtParaRight('.purposeDecoTxt');
    txtParaRight('.creativityDecoTxt');
    txtParaRight('.storiesDecoTxt');

    $(window).on('load scroll', function () {
      txtParaRight('.missionDecoTxt');
      txtParaRight('.purposeDecoTxt');
      txtParaRight('.creativityDecoTxt');
      txtParaRight('.storiesDecoTxt');

      aboutUsCommonAnimeFunc();
      aboutUsStoriesListMainviewAnimeFunc();

      // if(aboutUsPurposePage){
      //   aboutUsPurposeScrFunc();
      // }
    });

    // $(window).on('wheel', function () {
    //   if(aboutUsPurposePage){
    //     aboutUsPurposeAnimeFunc();
    //   }
    // });
    // $(window).on('touchmove', function () {
    //   if(aboutUsPurposePage){
    //     aboutUsPurposeAnimeFunc();
    //   }
    // });
    // $(window).on('click', function () {
    //   if(aboutUsPurposePage){
    //     aboutUsPurposeAnimeFunc();
    //   }
    // });

    let setTimer = false;
    function doReload() {
      if(aboutUsPurposePage && animatePurposeFlag01 && !animateScrollFlag10){

        $('body').removeClass('fixedBody').css({
          'top': 0
        });

        var winH = $(window).height();
        var objH = $('#correlationDiagram').outerHeight();
        var objTop = $('#correlationDiagram').offset().top;
        var objBottom = objTop + objH;

        $('body,html').animate({
          scrollTop: objBottom - winH
        }, 1000)
        .promise()
        .done(function() {
          let scrollResizePosition = $(window).scrollTop();
          scrollPosition = $(window).scrollTop();
          
          $('body').addClass('fixedBody').css({
            'top': -scrollResizePosition,
            'overflow-y': 'scroll',
          });
          header.classList.add('changeHeightAbout');
          subNav.classList.add('notTopAbout');
        });
      }
    }
    function orientationCheck() {
      var w = $(window).width();
      var h = $(window).height();
      if(w < h) {
          return 'portrait';
      } else {
          return 'landscape';
      }
    }
    var current = orientationCheck(); // 現在の端末の向きを保存

    $(window).on('resize', function () {
      // 端末の向きが変更されたとき
      let ua = navigator.userAgent;
      if ((ua.indexOf('iPad') > 0 || ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0) && ua.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('Safari') > 0 && navigator.userAgent.indexOf('Chrome') == -1 && typeof document.ontouchstart !== 'undefined') {
        if(current != orientationCheck()) {
          current = orientationCheck(); // 端末の向きを更新
          doReload();
        }
        return false
      } else {
        if (setTimer !== false) {
          clearTimeout(setTimer);
        }
        setTimer = setTimeout(() => {
          //処理
          doReload();
        }, 200);
      }
    });
  }

  if(aboutUsCreativity){

    if(aboutUsCreativityPage){
      const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));

      function creativityPassionAnimeFunc() {
        $('.creativityPassion').each(function () {
          var position = $(this).offset().top;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
    
          if (scroll > position - windowHeight + 200) {
            wait(0)
            .then(() => {
              $(this).find('.creativityPassionLead').addClass('isShow');
              $(this).find('.imgBox01').addClass('isShow');
              $(this).find('.imgBox02').addClass('isShow');
              return wait(500)
            })
            .then(() => {
              $(this).find('.creativityPassionTxt').addClass('isShow');
              return wait(100)
            })
          }
        });
      }

      var bottomScroll = $('#bottomScroll');
      var timer;

      creativityPassionAnimeFunc();
      $(window).on('load scroll', function () {
        creativityPassionAnimeFunc();

        // bottomScroll.removeClass('activeScr');
        
        // //スクロール中はイベントの発火をキャンセルする
        // clearTimeout(timer);
        // timer = setTimeout(function() {
        //   if($(this).scrollTop()) {
        //     bottomScroll.addClass('activeScr');
        //   }else{
        //     bottomScroll.removeClass('activeScr');
        //   }
        // }, 200);
      });

      let setTimer = false;
      var prewidth = $(window).width();
      function doReloadWithCache() {
        // キャッシュを利用してリロード
        window.location.reload(false);
      }
      $(window).on('resize', function () {  
        if (resizecheck == '1'){
          if (setTimer !== false) {
            clearTimeout(setTimer);
          }
          setTimer = setTimeout(() => {
              var nowWidth = $(window).width();
              if(prewidth !== nowWidth){
                doReloadWithCache();
              }
              prewidth = nowWidth;
              gsap.matchMediaRefresh();
          }, 200);
        }
      });

      $('.imgSlide').each(function (i) {
        var $_t = $(this);
        let slideClass = $_t.addClass('slide' + i)
    
        //スライダー部分
        slideClass.slick({
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 800,
          dots: false,
          arrows: false,
          cssEase: 'cubic-bezier(.41,.06,.7,.97)',
          pauseOnFocus: false,
          pauseOnHover: false,
          pauseOnDotsHover: false,
          draggable: false,
          touchMove: false,
          swipe: false,
          //useTransform: false,
        });
      });

      $('.commonImgSlide').each(function (i) {
        var $_t = $(this);
        let slideClass = $_t.addClass('slide' + i)
    
        //スライダー部分
        slideClass.slick({
          loop: true,
          autoplay: true,
          autoplaySpeed: 1000,
          speed: 4000,
          dots: false,
          arrows: false,
          fade: true,
          infinite: true,
          pauseOnFocus: false,
          pauseOnHover: false,
          pauseOnDotsHover: false,
          draggable: false,
          touchMove: false,
          swipe: false,
        }).slick('slickPause');
    
        function triggerScroll(targetObj) {
          let targetFlag = false;
    
          let scrollTop = $(window).scrollTop();
          let scrollBottom = scrollTop + $(window).height();
          let targetTop = targetObj.offset().top;
          let targetBottom = targetTop + targetObj.height();
    
          if (scrollBottom > targetTop && scrollTop < targetBottom) {
            if (!targetFlag) {
              targetObj.slick('slickPlay');
              targetFlag = true;
            }
          }
    
          let setTimer = false;
          $(window).on('scroll', function () {
            if (setTimer !== false) {
              clearTimeout(setTimer);
            }
            setTimer = setTimeout(() => {
              scrollTop = $(window).scrollTop();
              scrollBottom = scrollTop + $(window).height();
              targetTop = targetObj.offset().top;
              targetBottom = targetTop + targetObj.height();
    
              if (scrollBottom > targetTop && scrollTop < targetBottom) {
                if (!targetFlag) {
                  targetObj.slick('slickPlay');
                  targetFlag = true;
                }
              }
            }, 200);
    
          });
        }
        triggerScroll(slideClass);
      });

      // タイムラインアニメーションの作成
      const header = document.getElementById("header");

      ScrollTrigger.config({ 
        ignoreMobileResize: true,
      })

      //イノベーティブなデザイン
      const topTl = gsap.timeline({
        scrollTrigger: {
          trigger: ".creativityInnovativeDesignBigImageArea",
          start: "top bottom",
          end: "bottom top-=200%",
          scrub: 3,
          pinnedContainer: true,
        },
      });
      topTl.fromTo(
        "#innovativeDesignBigImage", {
          scale: 1.5,
        }, {
          scale: 1,
          ease: "Power4.out"
        }
      );

      let innovativeDesignDecoTxtW;
      if (resizecheck == '1'){
        innovativeDesignDecoTxtW = $('#innovativeDesignDecoTxt').width() / 2;
      } else{
        innovativeDesignDecoTxtW = -($('#innovativeDesignDecoTxt').width() / 10);
      }
      gsap.to("#innovativeDesignDecoTxt",{
        scrollTrigger: {
          trigger: '.creativityInnovativeDesignBigImageArea',
          start: "top center",
          end: "bottom top-=200%",
          scrub: true,
        },
        left: () => (innovativeDesignDecoTxtW),
        invalidateOnRefresh: true,
      });

      let creativityInnovativeStart;
      if (resizecheck == '1'){
        creativityInnovativeStart = "bottom bottom";
      } else{
        creativityInnovativeStart = `center center+=${header.clientHeight}`;
      }
      // ScrollTrigger.create({
      //   trigger: '.creativityInnovativeDesignBigImageArea',
      //   start: () => creativityInnovativeStart,
      //   end: "bottom top-=200%",
      //   pin: true,
      //   anticipatePin: 1,
      //   invalidateOnRefresh: true,
      // });
      ScrollTrigger.create({
        trigger: '.creativityInnovativeDesignBigImageArea',
        start: "top bottom+=30",
        end: "bottom top-=200",
        toggleClass: {targets: ".creativityInnovativeDesignBigImageArea", className: "isActive"}, //クラスをつけたり、外したりできる
        once: true
      });
      // ScrollTrigger.create({
      //   trigger: '.creativityInnovativeDesignBigImageArea',
      //   start: "top bottom+=40",

      //   onEnter: () => {
      //     document.getElementById("bottomScroll").classList.add("active");
      //   },
      //   onLeaveBack: () => {
      //     document.getElementById("bottomScroll").classList.remove("active");
      //   }
      // });

      // ScrollTrigger.create({
      //   trigger: '.creativityInnovativeDesignMainTxtArea',
      //   pin: true,
      //   start: () =>`top +=${header.clientHeight}`,
      //   end: "bottom top-=150%",
      //   invalidateOnRefresh: true,
      //   anticipatePin: 1,
      // });
      let creativityInnovativeTxtAreaStart;
      if (resizecheck == '1'){
        creativityInnovativeTxtAreaStart = "top center";
      } else{
        creativityInnovativeTxtAreaStart = `top bottom-=${header.clientHeight}`;
      }
      ScrollTrigger.create({
        trigger: '.creativityInnovativeDesignMainTxtArea',
        start: () => creativityInnovativeTxtAreaStart,
        end: "bottom top-=200",
        toggleClass: {targets: ".creativityInnovativeDesignMainTxtArea, .creativityInnovativeDesignMainTxtArea .txt, .creativityInnovativeDesignMainTxtArea .imgBox", className: "isShow"}, //クラスをつけたり、外したりできる
        once: true
      });
      // const txtAreaTl = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: '.creativityInnovativeDesignMainTxtArea',
      //     start: () =>`top +=${header.clientHeight}`,
      //     end: "bottom top-=100%",
      //     invalidateOnRefresh: true,
      //     scrub: 2,
      //   },
      // });
      // txtAreaTl.to(".innovativeDesignScrollImg02", {
      //   yPercent: -100,
      // }, ".2");
      
      //素材研究・技術開発
      const topTl2 = gsap.timeline({
        scrollTrigger: {
          trigger: ".creativityResearchDevelopmentBigImageArea",
          start: "top bottom",
          end: "bottom top-=200%",
          scrub: 3,
          pinnedContainer: true,
        },
      });
      topTl2.fromTo(
        "#researchDevelopmentBigImage", {
          scale: 1.5,
        }, {
          scale: 1,
          ease: "Power4.out"
        }
      );

      let researchDevelopmentDecoTxtW;
      if (resizecheck == '1'){
        researchDevelopmentDecoTxtW = $('#innovativeDesignDecoTxt').width() / 2;
      } else{
        researchDevelopmentDecoTxtW = -($('#innovativeDesignDecoTxt').width() / 10);
      }
      gsap.to("#researchDevelopmentDecoTxt",{
        scrollTrigger: {
          trigger: '.creativityResearchDevelopmentBigImageArea',
          start: "top center",
          end: "bottom top-=200%",
          scrub: true,
        },
        left: () => (researchDevelopmentDecoTxtW),
        invalidateOnRefresh: true,
      });

      let creativityResearchDevelopmentStart;
      if (resizecheck == '1'){
        creativityResearchDevelopmentStart = "bottom bottom";
      } else{
        creativityResearchDevelopmentStart = `center center+=${header.clientHeight}`;
      }
      // ScrollTrigger.create({
      //   trigger: '.creativityResearchDevelopmentBigImageArea',
      //   start: () => creativityResearchDevelopmentStart,
      //   end: "bottom top-=200%",
      //   pin: true,
      //   anticipatePin: 1,
      //   invalidateOnRefresh: true,
      // });
      ScrollTrigger.create({
        trigger: '.creativityResearchDevelopmentBigImageArea',
        start: "top bottom+=30",
        end: "bottom top-=200",
        toggleClass: {targets: ".creativityResearchDevelopmentBigImageArea", className: "isActive"}, //クラスをつけたり、外したりできる
        once: true
      });

      // ScrollTrigger.create({
      //   trigger: '.creativityResearchDevelopmentMainTxtArea',
      //   pin: true,
      //   start: () =>`top +=${header.clientHeight}`,
      //   end: "bottom top-=150%",
      //   invalidateOnRefresh: true,
      //   anticipatePin: 1,
      // });
      let creativityResearchTxtAreaStart;
      if (resizecheck == '1'){
        creativityResearchTxtAreaStart = "top center";
      } else{
        creativityResearchTxtAreaStart = `top bottom-=${header.clientHeight}`;
      }
      ScrollTrigger.create({
        trigger: '.creativityResearchDevelopmentMainTxtArea',
        start: () => creativityResearchTxtAreaStart,
        end: "bottom top-=200",
        toggleClass: {targets: ".creativityResearchDevelopmentMainTxtArea, .creativityResearchDevelopmentMainTxtArea .txt, .creativityResearchDevelopmentMainTxtArea .imgBox", className: "isShow"}, //クラスをつけたり、外したりできる
        once: true
      });
      // const txtAreaTl2 = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: '.creativityResearchDevelopmentMainTxtArea',
      //     start: () =>`top +=${header.clientHeight}`,
      //     end: "bottom top-=100%",
      //     scrub: 2,
      //     invalidateOnRefresh: true,
      //   },
      // });
      // txtAreaTl2.to(".researchDevelopmentScrollImg02", {
      //   yPercent: -100,
      // }, ".2");

      //量産技術
      const topTl3 = gsap.timeline({
        scrollTrigger: {
          trigger: ".creativityProductionTechnologyBigImageArea",
          start: "top bottom",
          end: "bottom top-=200%",
          scrub: 3,
          pinnedContainer: true,
        },
      });
      topTl3.fromTo(
        "#productionTechnologyBigImage", {
          scale: 1.5,
        }, {
          scale: 1,
          ease: "Power4.out"
        }
      );

      let productionTechnologyDecoTxtW;
      if (resizecheck == '1'){
        productionTechnologyDecoTxtW = $('#innovativeDesignDecoTxt').width() / 2;
      } else{
        productionTechnologyDecoTxtW = -($('#innovativeDesignDecoTxt').width() / 10);
      }
      gsap.to("#productionTechnologyDecoTxt",{
        scrollTrigger: {
          trigger: '.creativityProductionTechnologyBigImageArea',
          start: "top center",
          end: "bottom top-=200%",
          scrub: true,
        },
        left: () => (productionTechnologyDecoTxtW),
        invalidateOnRefresh: true,
      });

      let creativityProductionTechnologyStart;
      if (resizecheck == '1'){
        creativityProductionTechnologyStart = "bottom bottom";
      } else{
        creativityProductionTechnologyStart = `center center+=${header.clientHeight}`;
      }
      // ScrollTrigger.create({
      //   trigger: '.creativityProductionTechnologyBigImageArea',
      //   start: () => creativityProductionTechnologyStart,
      //   end: "bottom top-=200%",
      //   pin: true,
      //   anticipatePin: 1,
      //   invalidateOnRefresh: true,
      // });
      ScrollTrigger.create({
        trigger: '.creativityProductionTechnologyBigImageArea',
        start: "top bottom+=30",
        end: "bottom top-=200",
        toggleClass: {targets: ".creativityProductionTechnologyBigImageArea", className: "isActive"}, //クラスをつけたり、外したりできる
        once: true
      });

      // ScrollTrigger.create({
      //   trigger: '.creativityProductionTechnologyMainTxtArea',
      //   pin: true,
      //   start: () =>`top +=${header.clientHeight}`,
      //   end: "bottom top-=150%",
      //   invalidateOnRefresh: true,
      //   anticipatePin: 1,
      // });
      let creativityProductionTxtAreaStart;
      if (resizecheck == '1'){
        creativityProductionTxtAreaStart = "top center";
      } else{
        creativityProductionTxtAreaStart = `top bottom-=${header.clientHeight}`;
      }
      ScrollTrigger.create({
        trigger: '.creativityProductionTechnologyMainTxtArea',
        start: () => creativityProductionTxtAreaStart,
        end: "bottom top-=200",
        toggleClass: {targets: ".creativityProductionTechnologyMainTxtArea, .creativityProductionTechnologyMainTxtArea .txt, .creativityProductionTechnologyMainTxtArea .imgBox", className: "isShow"}, //クラスをつけたり、外したりできる
        once: true
      });
      // const txtAreaTl3 = gsap.timeline({
      //   scrollTrigger: {
      //     trigger: '.creativityProductionTechnologyMainTxtArea',
      //     start: () =>`top +=${header.clientHeight}`,
      //     end: "bottom top-=100%",
      //     scrub: 2,
      //     invalidateOnRefresh: true,
      //   },
      // });
      // txtAreaTl3.to(".productionTechnologyScrollImg02", {
      //   yPercent: -100,
      // }, ".2");


      const listWrapperEl = document.querySelector('.creativityManufacturingProcess');
      const listEl = document.querySelector('.manufacturingProcessWrap');
      const listElW = document.querySelector('.creativityManufacturingProcessBigImageArea');
      var scrollTween;

      const topTl4 = gsap.timeline({
        scrollTrigger: {
          trigger: ".creativityManufacturingProcessBigImageArea",
          start: "top bottom",
          end: "bottom top-=200%",
          scrub: 3,
          pinnedContainer: true,
        },
      });
      topTl4.fromTo(
        "#manufacturingProcessBigImage", {
          scale: 1.5,
        }, {
          scale: 1,
          ease: "Power4.out"
        }
      );

      ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () { 
          ScrollTrigger.create({
            trigger: '.creativityManufacturingProcess',
            start: () => "bottom bottom",
            end: () => `+=${listEl.clientWidth}`,
            pin: true,
            anticipatePin: 1,
            invalidateOnRefresh: true,

            // onEnter: () => {
            //   document.getElementById("bottomScroll").classList.remove("active");
            // },
            // onLeaveBack: () => {
            //   document.getElementById("bottomScroll").classList.add("active");
            // }
          });

          scrollTween = gsap.to('.manufacturingProcessWrap', {
            x: () => -(listEl.clientWidth),
            ease: 'none',
            scrollTrigger: {
              trigger: ".creativityManufacturingProcessBigImageArea",
              start: () => "bottom bottom",
              endTrigger: '.creativityManufacturingProcess',
              end: () => `+=${listEl.clientWidth}`,
              scrub: 0.1,
              //pin: true,
              toggleClass: {targets: "#header,#subNav", className: "isHidden"}, //クラスをつけたり、外したりできる
              invalidateOnRefresh: true,
            },
          });
          // gsap.to("#pcManufacturingProcessNavBox", {
          //   x: () => (listEl.clientWidth),
          //   ease: 'none',
          //   scrollTrigger: {
          //     trigger: ".creativityManufacturingProcess",
          //     start: "bottom bottom",
          //     end: () => `+=${listEl.clientWidth}`,
          //     scrub: 0.1,
          //     invalidateOnRefresh: true,
          //   },
          // });
          gsap.to("#pcManufacturingProcessNavBox",{
            scrollTrigger: {
              trigger: '.manufacturingProcessWrap',
              containerAnimation: scrollTween,
              start: "left 15%",
              endTrigger: '.manufacturingProcessWrap',
              end: "bottom top",
              anticipatePin: 1,
    
              onEnter: () => {
                document.getElementById("pcManufacturingProcessNavBox").classList.add("active");
              },
              onLeaveBack: () => {
                document.getElementById("pcManufacturingProcessNavBox").classList.remove("active");
              }
            },
          });
          // ScrollTrigger.create({
          //   trigger: '.creativityManufacturingProcessBigImageArea',
          //   start: "top bottom",
    
          //   onEnter: () => {
          //     document.getElementById("bottomScroll").classList.remove("active");
          //   },
          //   onLeaveBack: () => {
          //     document.getElementById("bottomScroll").classList.add("active");
          //   }
          // });
        },
        // "(max-width: 767px)": function() {
        //   ScrollTrigger.create({
        //     trigger: '.creativityManufacturingProcessBigImageArea',
        //     start: () => `center center+=${header.clientHeight}`,
        //     end: "bottom top-=200%",
        //     pin: true,
        //     anticipatePin: 1,
        //     invalidateOnRefresh: true,
        //   });
        //   ScrollTrigger.create({
        //     trigger: '.manufacturingProcessWrap',
        //     start: "top bottom",
    
        //     onEnter: () => {
        //       document.getElementById("bottomScroll").classList.remove("active");
        //     },
        //     onLeaveBack: () => {
        //       document.getElementById("bottomScroll").classList.add("active");
        //     }
        //   });
        // }
      });

      let modules = document.querySelectorAll('.manufacturingProcess');
      const navLinks = gsap.utils.toArray(".anchor");
      const navLinksSP = gsap.utils.toArray(".spAnchor");
      modules.forEach((module, i) => {
        gsap.to(module, {
          ease: "none",
          scrollTrigger: {
            trigger: module,
            containerAnimation: scrollTween,
            toggleClass: "active",
            start: "left 52%",
            end: "right 48%",
            anticipatePin: 1,
            invalidateOnRefresh: true,

            onEnter: () => {
              navLinks.forEach((e) => {
                e.classList.remove("active");
              });
              navLinks[i].classList.add("active");

              navLinksSP.forEach((e) => {
                e.classList.remove("active");
              });
              navLinksSP[i].classList.add("active");

              module.classList.add("arrowActive");
            },
            onEnterBack: () => {
              navLinks.forEach((e) => {
                e.classList.remove("active");
              });
              navLinks[i].classList.add("active");

              navLinksSP.forEach((e) => {
                e.classList.remove("active");
              });
              navLinksSP[i].classList.add("active");
            },
          }
        });
      });

      let manufacturingProcessDecoTxtW,manufacturingProcessStart;
      if (resizecheck == '1'){
        manufacturingProcessDecoTxtW = $('#innovativeDesignDecoTxt').width() / 2;
        manufacturingProcessStart = "bottom bottom";
      } else{
        manufacturingProcessDecoTxtW = -($('#innovativeDesignDecoTxt').width() / 10);
        manufacturingProcessStart = `center center+=${header.clientHeight}`;
      }
      gsap.to("#manufacturingProcessDecoTxt",{
        scrollTrigger: {
          trigger: '.creativityManufacturingProcessBigImageArea',
          start: () => manufacturingProcessStart,
          end: "bottom top-=200%",
          scrub: true,
        },
        left: () => (manufacturingProcessDecoTxtW),
        invalidateOnRefresh: true,
      });
      ScrollTrigger.create({
        trigger: '.creativityManufacturingProcessBigImageArea',
        start: "top bottom+=30",
        toggleClass: {targets: ".creativityManufacturingProcessBigImageArea", className: "isActive"}, //クラスをつけたり、外したりできる
        once: true,
      });

      const anchors = document.querySelectorAll('.manufacturingProcessNavAnchor');
      let trigger = document.getElementById("scrollPoint");
      let clientRect = trigger.getBoundingClientRect();
      const lhero = clientRect.top + window.pageYOffset;

      const lheroW = $('.manufacturingProcess').width() / .8;
      const lheroW2 = $('.manufacturingProcess').width() / 2.4;
      const imageAreaW = $('.creativityManufacturingProcessBigImageArea').width();

      let index = '';

      const breakPoint01 = 820;
      const breakPoint02 = 767;
      let windowWidth = window.innerWidth;


      anchors.forEach( (anchor) => {
          anchor.addEventListener( 'click', (e) => {
              e.preventDefault();
              
              index = [].slice.call(anchors).indexOf(anchor); // 何番目のアンカーリンクをクリックしたか取得
              const target = document.querySelector(e.currentTarget.querySelector('a').getAttribute('href')); // クリックしたアンカーリンクに紐づくpanelを取得
              let wrapperOffset02;//lhero + target.offsetLeft + imageAreaW - lheroW


              //要調整
              if (windowWidth > breakPoint02 && windowWidth <= breakPoint01) {
                wrapperOffset02 = scrollTween.scrollTrigger.start + target.offsetLeft + imageAreaW - window.innerWidth/4.1;
              } else {
                wrapperOffset02 = scrollTween.scrollTrigger.start + target.offsetLeft + imageAreaW - window.innerWidth/2.7;
              }
  
              gsap.to(window, {
                  scrollTo: {
                      y: wrapperOffset02,
                      autoKill: false,
                  },
                  duration: 1.5,
                  invalidateOnRefresh: true,
              });
          });
      });

      const headerH = $('#header').height();
      const navBoxH = $('#spManufacturingProcessNavBox').height();

      navLinksSP.forEach((btn, index) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();

          gsap.to(window, {
            duration: 1,
            scrollTo: { 
              y: "#panel0" + (index + 1),
              offsetY: () => `${headerH + navBoxH + 30}`,
            }
          });
        });
      });
    }
  }
}